<div *ngIf="device" class="basket-item mt-6 mb-8">
  <div class="flex justify--space-between typog-body-large-bold">
    {{ device.title }}
    <span
      class="basket-item__device-price typog-body-large-bold"
      *ngIf="device.price"
      >{{ device.price | currency: 'GBP' }}</span
    >
  </div>

  <div
    *ngIf="device.covered"
    class="basket-item__cover flex justify--space-between px-4 py-3 my-3"
  >
    Loss & theft cover added
    <span>{{ device.coverPrice | currency: 'GBP' }}</span>
  </div>

  <div class="basket-item__image-wrap">
    <img
      class="basket-item__image mt-6"
      [src]="device.image"
      [alt]="device.title"
    />
    <div class="flex justify--space-between mt-6" *ngIf="!readOnly">
      <!--
      TODO: uncomment when https://domgen.atlassian.net/browse/AOWLP-836 is done
      <a
        *ngIf="allowEdit"
        class="link typog-body-bold"
        (click)="handleEdit(device.id)"
        >Edit</a
      >
      -->
      <!--// this work around will be removed next release-->
      <a
        *ngIf="device.title !== 'Sky Glass'"
        class="link typog-body-bold"
        (click)="handleRemove(device)"
        >Remove</a
      >
    </div>
  </div>
</div>
